import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default function useTeesheetIntegration() {
  const store = useStore();

  const targetCourse = ref(null);
  const targetProvider = ref(null);

  const providerObject = computed(
    () => store.getters["teesheet/getProviderObject"]
  );
  const courseIntegration = computed(
    () => store.getters["teesheet/getCourseIntegration"]
  );
  const loadingSetup = ref(false);
  const suppressProviderWatch = ref(false);
  const configText = ref("");

  const courses = computed(() => store.getters["courses/getCourseNames"]);
  const providers = computed(() => store.getters["teesheet/getProviders"]);

  watch(providerObject, (newVal) => {
    if (newVal !== "") {
      const jsonCopy = JSON.parse(providerObject.value);
      configText.value = JSON.stringify(jsonCopy, null, 4);
    } else {
      configText.value = "";
    }
  });

  watch(targetProvider, (newVal) => {
    if (newVal && !suppressProviderWatch.value) {
      try {
        store.dispatch("teesheet/fetchProviderObject", newVal.id);
      } catch (error) {
        console.error("Error fetching provider object:", error);
      }
    } else if (!newVal) {
      store.commit("teesheet/SET_PROVIDER_OBJECT", "");
      console.log("No provider selected");
    }
    suppressProviderWatch.value = false;
  });

  watch(courseIntegration, (newVal) => {
    if (newVal) {
      configText.value = JSON.stringify(newVal.config || newVal, null, 4);
      const providerMatch = providers.value.find(
        (p) => p.slug.toLowerCase() == newVal.provider.toLowerCase()
      );
      if (providerMatch) {
        suppressProviderWatch.value = true;
        targetProvider.value = providerMatch;
        configText.value = JSON.stringify(newVal.config || newVal, null, 4);
      }
    } else {
      configText.value = "";
    }
  });

  watch(targetCourse, async (newVal) => {
    if (newVal) {
      targetProvider.value = null;
      configText.value = "";
      await store.dispatch("teesheet/fetchCourseIntegration", newVal.id);
    } else {
      targetProvider.value = null;
      configText.value = "";
    }
  });

  const setupIntegration = async () => {
    loadingSetup.value = true;

    try {
      const payload = {
        id: targetCourse.value.id,
        data: configText.value,
      };
      const response = await store.dispatch(
        "teesheet/updateProviderObject",
        payload
      );

      store.dispatch("toastNotification/displayToast", {
        message: response.data?.message || `Course updated successfully`,
        type: "success",
        duration: 3000,
      });
      loadingSetup.value = false;
    } catch (error) {
      store.dispatch("toastNotification/displayToast", {
        message:
          error?.data?.message ||
          `Failed to setup integration for ${targetCourse.value.name}`,
        type: "error",
        duration: 6000,
      });
      console.error("Error updating provider object:", error);
      loadingSetup.value = false;
    }
    console.log("Setting up integration for course:", targetCourse.value);
    console.log("Configuration:", configText.value);
  };

  onMounted(() => {
    store.dispatch("courses/fetchCourseNames");
    store.dispatch("teesheet/fetchProviders");
  });

  return {
    targetCourse,
    targetProvider,
    providerObject,
    configText,
    courses,
    providers,
    loadingSetup,
    setupIntegration,
    courseIntegration,
  };
}
